import { BUTTON_LINK } from '../classnames/design-system';
import { addLoadingState, removeLoadingState } from '../shared/loading-state-helpers';

export default class ButtonLinks {
  addLoadingState = (event) => {
    addLoadingState(event.target);

    setTimeout(() => removeLoadingState(event.target), 1000);
  };

  addClickHandler = (link) => {
    link.addEventListener('click', this.addLoadingState);
  };

  initializeEventListeners = () => {
    document.querySelectorAll(`.${BUTTON_LINK}`).forEach(this.addClickHandler);
  };
}
